<template>
    <div class="flex items-center cursor-pointer"
        @click="toggle">
        <div class="flex items-center"
            style="width: 24px;">
            <checkbox-icon v-if="isChecked"
                class="text-blue-500"></checkbox-icon>
            <checkbox-outline-icon class="text-gray-500" v-else></checkbox-outline-icon>
        </div>
        <div class="ml-1 text-gray-700">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    import findIndex from 'lodash/findIndex';
    export default {
        props: {
            value: false,
            altValue: null,
            checkValue: null,
            uncheckValue: null,
        },
        components: {
            CheckboxIcon: () =>
                import ( /* webpackChunkName: "checkbox-icon" */ '@/icons/Checkbox.vue'),
            CheckboxOutlineIcon: () =>
                import ( /* webpackChunkName: "checkbox-outline-icon" */ '@/icons/CheckboxOutline.vue')
        },
        computed: {
            isChecked() {
                if (typeof this.value === 'boolean') {
                    return this.value
                }

                if (typeof this.value === 'object') {
                    return findIndex(this.value, (item) => {
                        return item === this.altValue
                    }) !== -1
                }

                
                return this.value === this.checkValue;
            }
        },
        methods: {
            toggle() {
                if (typeof this.value === 'boolean') {
                    if (this.value) {
                        this.$emit('input', false)
                    } else {
                        this.$emit('input', true)
                    }
                }

                if (typeof this.value === 'object') {
                    let value = this.value
                    let index = findIndex(this.value, (item) => {
                        return item === this.altValue
                    })

                    if (index === -1) {
                        value.push(this.altValue)
                        this.$emit('input', value)
                    } else {
                        value.splice(index, 1)
                        this.$emit('input', value)
                    }
                }

                if (this.value === this.checkValue) {
                    this.$emit('input', this.uncheckValue);
                }

                if (this.value === this.uncheckValue) {
                    this.$emit('input', this.checkValue);
                }
            }
        }
    }
</script>